import { USERS_EVENT_ROLES } from '@/utils/constants';

export function isCandidateParticipating(event) {
  return event.isAuthUserParticipating || event?.userContext?.roles?.includes(USERS_EVENT_ROLES.participant)
}
